import React from "react";

type Props = {};

const OtherAssetsHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<p className="leading-para text-greyDark mb-4">
				In addition to conventional investments like stocks, mutual funds, RSUs, foreign stocks,
				land, bonds, and debentures, individuals often invest in distinctive capital assets such as
				Jewellery, Paintings, Sculptures, Archaeological Collections, Coins, and more. These assets
				can be traded, and any resulting gains or losses are subject to capital gains tax.
			</p>
			<p className="leading-para text-greyDark">
				Please provide details of any such assets you have sold, including the associated gains or
				losses, in this section
			</p>
		</>
	);
};

export default OtherAssetsHint;
